<app-dynamic-form
  [clientId]="clientId"
  [patientId]="patientId"
  [templateId]="templateId"  *ngIf="templateId && templateId != ''">
</app-dynamic-form>
